import { preOrderSwiper } from "../vendor/swiper"
var selected_order = {}

var swiper

var currentSlideIndex = 0

function setClickedImage(element) {
  const imageURL = element.attr("src")
  $(".pre-order_touch").css("background-image", `url(${imageURL})`)
  selected_order["touch"] = imageURL
}

function setPrice(element) {
  const price = Math.floor(Number(element.data().price.replace(",", "")) * 1.1)
  $(".pre-order_touch-name").show()
  $(".pre-order_detail-item--touch").show()

  $(".pre-order_price").find("span").html(price)
  $(".pre-order_total-price").find("span").html(price)
}

function setActiveToBar(element) {
  // アクティブなステップの場合は何もしない
  if (element.hasClass("pre-stepbar--active")) {
    return
  }

  // まずアクティブなやつを元に戻す
  $(".pre-stepbar_step").each(function (_, element) {
    $(element).removeClass("pre-stepbar_step--active")
  })

  // 選択されたステップにクラスを付与
  element.addClass("pre-stepbar_step--active")

  // 選択しない用のクラスを削除
  element.removeClass("step-disable")
}

function slide(slideNumber) {
  swiper.slideTo(slideNumber)
}

$(function () {
  swiper = preOrderSwiper()

  // まず選択されたタッチ画像の部分を隠しておく
  $(".pre-order_detail-item--touch").hide()

  // タッチ画像を選択した際の処理
  $(".pre-order_item-image").on("click", function () {
    setClickedImage($(this))
    setPrice($(this))

    selected_order["plan"] = $(this).data("plan")

    currentSlideIndex += 1
    setActiveToBar($(".pre-stepbar_step[data-step='" + currentSlideIndex + "'"))
    swiper.slideNext()
  })

  // ステップバーを選択した際の処理
  $(".pre-stepbar_step").on("click", function () {
    // まだ選択できない場合は何もしない
    if ($(this).hasClass("step-disable")) {
      return
    }

    setActiveToBar($(this))
    const toSlideIndex = $(this).data().step
    currentSlideIndex = toSlideIndex
    slide(toSlideIndex)
  })

  // アカウント登録する際の処理
  $("#pre-order_form").on("submit", function () {
    var form = $("#pre-order_form")

    var hiddenInputOrders = $("<input>", {
      type: "hidden",
      name: "pre_order",
      value: JSON.stringify(selected_order),
    }).appendTo(form)

    form.submit()
  })
})
